import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ToastrModule } from 'ngx-toastr';
import { NgBusyModule } from 'ng-busy';

import { RouterModule } from '@angular/router';

import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule
} from '@angular-material-components/datetime-picker';

import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabLink, MatTabsModule } from '@angular/material/tabs';

// Components
import { CreateOrEditMedicalFormulaComponent } from './clinicHistory/createOrEditMedicalFormula.component';
import { ClinicHistoryComponent } from './clinicHistory/clinicHistory.component';
import { CreateOrEditClinicHistoryComponent } from './clinicHistory/createOrEditClinicHistory.component';
import { ClinicHistoriesPatientComponent } from './clinicHistoriesPatient.component';
import { PatientComponent } from './patients.component';
import { CreateOrEditPatientComponent } from './createOrEditPatient.component';
import { SellComponent } from './sell/sell.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoicesTaskComponent } from './invoices-task/invoices-task.component';
import { OdontogramaComponent } from './odontologyHistory/odontograma/odontograma.component';
import { ToothStateComponent } from './odontologyHistory/tooth-state/tooth-state.component';
import { OdontologyHistoryComponent } from './odontologyHistory/odontologyHistory.component';
import { CreateOrEditOdontologyHistoryComponent } from './odontologyHistory/createOrEditOdontologyHistory.component';
import { OdontologyTissueComponent } from './odontologyHistory/odontology-tissue/odontology-tissue.component';
import { OdontogramaHistoryComponent } from './odontologyHistory/odontograma-history/odontograma-history.component';
import { QuoteComponent } from './odontologyHistory/quote/quote.component';
import { QuoteHistoryComponent } from './odontologyHistory/quote-history/quote-history.component';
import { ToothStateIconComponent } from './odontologyHistory/tooth-state-icon/tooth-state-icon.component';

import { VoiceWritingComponent } from './voiceWriting/voiceWriting.component';
import { VoiceWriting2Component } from './voice-writing2/voice-writing2.component';

import { Icd11EctComponent } from './icd11-ect-component/icd11-ect-component.component';
import { ECTAngularComponentComponent } from './ectangular-component/ectangular-component.component';

import { RemissionComponent } from './remission/remission.component';
import { RemissionHistoryComponent } from './remission/remissionHistory.component';

import { RelativeDiseaseComponent } from './relative-disease/relative-disease.component';
import { PatientAllergiesComponent } from './patient-allergies/patient-allergies.component';
import { PatientFarmacologicRecordComponent } from './patient-farmacologic-record/patient-farmacologic-record.component';
import { DialogAlertComponent } from './dialog-alert/dialog-alert.component';

// Services
import { ServiceTypeService } from '../services/service-type.service';
import { VoiceWritingService } from '../services/voiceWriting.service';
import { RemissionService } from '../services/remission.service';
import { BloodTypeService } from '../services/bloodType.service';
import { RelativeTypeService } from '../services/relativeType.service';
import { MedicAllergyTypeService } from '../services/medicAllergyType.service';
import { MedicineCommonNameTypeService } from '../services/medicineCommonNameType.service';
import { InamovibleCatalogService } from '../services/InamovibleCatalogService';
import { PatientRiskFactorComponent } from './patient-risk-factor/patient-risk-factor.component';
import { RiskFactorsTypeService } from '../services/riskFactorsType.service';
import { PatientRiskFactorService } from '../services/patientRiskFactor.service';
import { DiagnosticNovoComponent } from './diagnostic-novo/diagnostic-novo.component';
import { ExclusiveCheckboxComponent } from './exclusive-checkbox/exclusive-checkbox.component';
import { PatientClinicalDataService } from '../services/patientClinicalData.service';
import { ChControlComponent } from './ch-control/ch-control.component';
import { ChControlService } from '../services/chControl.service';
//import { OdontologyRadiologicExamPatientComponent } from './odontology-radiologic-exam-patient/odontology-radiologic-exam-patient.component';
import { OdontologyPatientBackgroundComponent } from './odontologyHistory/odontology-patient-background/odontology-patient-background.component';
import { OdontologyRadiologicExamPatientComponent } from './odontologyHistory/odontology-radiologic-exam-patient/odontology-radiologic-exam-patient.component';
import { QuotationComponent } from './odontologyHistory/quotation/quotation.component';
import { ClinicObservationComponent } from './clinic-observation/clinic-observation.component';

@NgModule({
  declarations: [
    CreateOrEditClinicHistoryComponent,
    CreateOrEditMedicalFormulaComponent,
    ClinicHistoryComponent,
    ClinicHistoriesPatientComponent,
    PatientComponent,
    CreateOrEditPatientComponent,
    SellComponent,
    DialogConfirmComponent,
    DialogAlertComponent,
    InvoicesComponent,
    InvoicesTaskComponent,
    OdontogramaComponent,
    ToothStateComponent,
    OdontologyHistoryComponent,
    CreateOrEditOdontologyHistoryComponent,
    OdontologyTissueComponent,
    OdontogramaHistoryComponent,
    QuoteComponent,
    QuoteHistoryComponent,
    VoiceWritingComponent,
    VoiceWriting2Component,
    Icd11EctComponent,
    ECTAngularComponentComponent,
    RemissionComponent,
    RemissionHistoryComponent,
    ToothStateIconComponent,
    RelativeDiseaseComponent,
    PatientAllergiesComponent,
    PatientFarmacologicRecordComponent,
    PatientRiskFactorComponent,
    DiagnosticNovoComponent,
    ExclusiveCheckboxComponent,
    ChControlComponent,
   // OdontologyRadiologicExamPatientComponent,
    OdontologyPatientBackgroundComponent,
    OdontologyRadiologicExamPatientComponent,
    QuotationComponent,
    ClinicObservationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ToastrModule.forRoot(),
    ModalModule.forRoot(),

    NgBusyModule,

    RouterModule,

    NgbModule,
    NgSelectModule,
    NgxMatSelectSearchModule,

    MatStepperModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTooltipModule,
    MatTabsModule,
    TooltipModule
  ],
  exports: [
    CreateOrEditClinicHistoryComponent,
    CreateOrEditMedicalFormulaComponent,
    ClinicHistoryComponent,
    OdontologyHistoryComponent,
    SellComponent,
    VoiceWritingComponent,
    VoiceWriting2Component,
    RemissionComponent,
    RemissionHistoryComponent,
    ToothStateIconComponent,
    PatientAllergiesComponent,
  ],
  providers: [
    ServiceTypeService,
    VoiceWritingService,
    RemissionService,
    BloodTypeService,
    RelativeTypeService,
    MedicAllergyTypeService,
    MedicineCommonNameTypeService,
    InamovibleCatalogService,
    RiskFactorsTypeService,
    PatientRiskFactorService,
    PatientClinicalDataService,
    ChControlService
  ],
  entryComponents: [
    DialogConfirmComponent,
    DialogAlertComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedchModule { }
